export default __webpack_public_path__ + "static/media/icon-seat.6fe06927.svg";